import { render, staticRenderFns } from "./VolleyArena.vue?vue&type=template&id=4180af67&scoped=true"
import script from "./VolleyArena.vue?vue&type=script&lang=js"
export * from "./VolleyArena.vue?vue&type=script&lang=js"
import style0 from "./VolleyArena.vue?vue&type=style&index=0&id=4180af67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4180af67",
  null
  
)

export default component.exports